export default [
  {
    path: '/crm',
    name: 'CrmOverviews',
    component: () => import('@/views/Crm/Index.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'Genel Bakış',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
  {
    path: '/crm/sales',
    name: 'CrmSales',
    component: () => import('@/views/Crm/Sales.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'Satış Şikayetleri',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
  {
    path: '/crm/services',
    name: 'CrmServices',
    component: () => import('@/views/Crm/Services.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'Servis Şikayetleri',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
  {
    path: '/crm/rentals',
    name: 'CrmRentals',
    component: () => import('@/views/Crm/Rentals.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'Filo Şikayetleri',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
  {
    path: '/crm/second-hands',
    name: 'CrmI2',
    component: () => import('@/views/Crm/SecondHands.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'İkinci El Şikayetleri',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
  {
    path: '/crm/csi',
    name: 'CrmCsi',
    component: () => import('@/views/Crm/Csi.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'CSI',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
  {
    path: '/crm/mystery-shopper',
    name: 'CrmMysteryShopper',
    component: () => import('@/views/Crm/MysteryShopper.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'Gizli Müşteri',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
  {
    path: '/crm/subjects',
    name: 'CrmSubjects',
    component: () => import('@/views/Crm/Subjects.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'En Çok Başvuru Konusu',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
  {
    path: '/crm/google-maps',
    name: 'CrmGoogleMaps',
    component: () => import('@/views/Crm/GoogleMaps.vue'),
    meta: {
      pageTitle: 'Müşteri Deneyimi',
      breadcrumb: [
        {
          text: 'Google Harita Puanları',
          active: true,
        },
      ],
      resource: 'RP_CRM',
      action: 'read',
    },
  },
]
